<div
  class="nav-sidebar-section__header"
  [attr.role]="expandable ? 'button' : null"
  [attr.tabindex]="expandable ? 0 : null"
  [class.nav-sidebar-section__header--static]="!expandable"
  [class.nav-sidebar-section__header--renaming]="isRenaming$ | async"
  [attr.aria-expanded]="expandable ? expanded : null"
  cdkDragHandle
  cdkDropList
  [id]="headerDropListId"
  [cdkDropListDisabled]="!headerDropListId || (expanded && expandable)"
  [cdkDropListConnectedTo]="headerDropListConnectedTo"
  (cdkDropListEntered)="headerDropListEntered.emit()"
  (cdkDropListExited)="headerDropListExited.emit()"
  (cdkDropListDropped)="headerDropListDropped.emit($event)"
  (click)="onHeaderClick()"
  (keydown.enter)="onHeaderClick()"
  (keydown.space)="onHeaderClick()"
>
  <span *ngIf="!renameable" class="nav-sidebar-section__label">{{ label }}</span>

  <!--
    Renameable sections swap the label for a textbox. It stays disabled until "Rename" is picked
    from the menu: app-extended-textbox shows a hover affordance whenever it's enabled, which here
    would wrongly suggest clicking the name edits it — the header click is expand/collapse.
  -->
  <app-extended-textbox
    *ngIf="renameable"
    #labelTextbox
    class="nav-sidebar-section__label nav-sidebar-section__label--editable"
    [mainText]="label"
    [disabled]="!(isRenaming$ | async)"
    [spanId]="'nav-sidebar-section-' + sectionId"
    [maxAllowedCharacters]="FOLDER_NAME_MAX_LENGTH"
    [disableWhenMaxLengthReached]="true"
    (editFinished)="onRenameFinished($event)"
  ></app-extended-textbox>

  <app-pencil-button
    *ngIf="menuContent"
    class="nav-sidebar-section__menu-btn"
    [class.nav-sidebar-section__menu-btn--open]="isMenuOpen$ | async"
    icon="ellipsis"
    [iconConfig]="{ type: IconTypes.lucideIcon }"
    [theme]="PencilButtonThemeEnum.ICON"
    buttonType="button"
    [attr.aria-label]="menuTitle"
    [matMenuTriggerFor]="(screenSizeService.renderMenuAsBottomSheet$ | async) ? null : sectionMenu"
    (menuOpened)="onMenuOpened()"
    (menuClosed)="onMenuClosed()"
    (click)="onMenuButtonClick($event)"
  ></app-pencil-button>

  <!-- Always rendered; the stylesheet decides when it's visible (see the hover rules there). -->
  <app-pencil-icon
    *ngIf="expandable"
    class="nav-sidebar-section__chevron"
    [class.nav-sidebar-section__chevron--expanded]="expanded"
    name="chevron-down"
    [type]="IconTypes.lucideIcon"
  ></app-pencil-icon>
</div>

<div
  class="nav-sidebar-section__body"
  [class.nav-sidebar-section__body--expanded]="expanded"
  [attr.aria-hidden]="!expanded"
  [attr.inert]="expanded ? null : ''"
>
  <div class="nav-sidebar-section__content">
    <ng-content></ng-content>
  </div>
</div>

<mat-menu
  #sectionMenu="matMenu"
  class="pencil-mat-menu light-scheme"
  xPosition="after"
  yPosition="above"
>
  <app-pncl-menu-header *ngIf="menuTitle" [title]="menuTitle | uppercase"></app-pncl-menu-header>
  <ng-container *ngTemplateOutlet="menuContent; context: { $implicit: menuContext }"></ng-container>
</mat-menu>

<ng-template #bottomSheetContainer>
  <app-pencil-bottom-sheet-container
    [title]="menuTitle"
    [colorScheme]="ColorScheme.LIGHT"
    (closeClicked)="dismissBottomSheet()"
  >
    <ng-container
      *ngTemplateOutlet="menuContent; context: { $implicit: menuContext }"
    ></ng-container>
  </app-pencil-bottom-sheet-container>
</ng-template>
